import React, { useState } from 'react';
import Modal from './Modal';
import FormField from './FormField';
import { FaPaperPlane, FaBullhorn, FaUser, FaUsers } from 'react-icons/fa';
import '../styles/MessageModal.css';

const MessageModal = ({
  isOpen,
  onClose,
  client,
  type = 'message' // 'message' ou 'publicity'
}) => {
  const [messageType, setMessageType] = useState('individual');
  const [messageForm, setMessageForm] = useState({
    subject: '',
    content: '',
    priority: 'normal',
    sendToAll: false
  });

  const handleFormChange = (value, field) => {
    setMessageForm(prev => ({ ...prev, [field]: value }));
  };

  const handleSendMessage = () => {
    console.log('Envoi message:', {
      type: messageType,
      client: client?.id,
      data: messageForm
    });
    
    // Réinitialiser le formulaire
    setMessageForm({
      subject: '',
      content: '',
      priority: 'normal',
      sendToAll: false
    });
    
    onClose();
  };

  const isPublicity = type === 'publicity';
  const modalTitle = isPublicity ? 'Envoyer une publicité' : 'Envoyer un message';

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={modalTitle}
      size="medium"
    >
      <div className="message-modal">
        {/* Type de message */}
        <div className="message-type-selector">
          <div className="type-option">
            <input
              type="radio"
              id="individual"
              name="messageType"
              value="individual"
              checked={messageType === 'individual'}
              onChange={(e) => setMessageType(e.target.value)}
            />
            <label htmlFor="individual" className="type-label">
              <FaUser className="type-icon" />
              <div>
                <div className="type-title">Message individuel</div>
                <div className="type-desc">
                  {client ? `À ${client.name}` : 'À un client spécifique'}
                </div>
              </div>
            </label>
          </div>

          <div className="type-option">
            <input
              type="radio"
              id="broadcast"
              name="messageType"
              value="broadcast"
              checked={messageType === 'broadcast'}
              onChange={(e) => setMessageType(e.target.value)}
            />
            <label htmlFor="broadcast" className="type-label">
              <FaUsers className="type-icon" />
              <div>
                <div className="type-title">Message groupé</div>
                <div className="type-desc">À tous les clients</div>
              </div>
            </label>
          </div>
        </div>

        {/* Formulaire */}
        <div className="message-form">
          <FormField
            label="Sujet"
            name="subject"
            value={messageForm.subject}
            onChange={handleFormChange}
            placeholder={isPublicity ? "Titre de la publicité" : "Objet du message"}
            required
          />

          <FormField
            label={isPublicity ? "Contenu publicitaire" : "Message"}
            name="content"
            type="textarea"
            rows={6}
            value={messageForm.content}
            onChange={handleFormChange}
            placeholder={isPublicity ? 
              "Décrivez votre offre, promotion ou annonce..." : 
              "Rédigez votre message..."
            }
            required
          />

          <div className="form-row">
            <FormField
              label="Priorité"
              name="priority"
              type="select"
              value={messageForm.priority}
              onChange={handleFormChange}
              options={[
                { value: 'low', label: 'Faible' },
                { value: 'normal', label: 'Normale' },
                { value: 'high', label: 'Élevée' },
                { value: 'urgent', label: 'Urgente' }
              ]}
            />
          </div>

          {isPublicity && (
            <div className="publicity-options">
              <h4>Options publicitaires</h4>
              <FormField
                name="sendToAll"
                type="checkbox"
                value={messageForm.sendToAll}
                onChange={handleFormChange}
                label="Envoyer à tous les clients actifs"
              />
            </div>
          )}
        </div>

        {/* Aperçu */}
        <div className="message-preview">
          <h4>Aperçu</h4>
          <div className="preview-card">
            <div className="preview-header">
              <div className="preview-subject">
                {messageForm.subject || (isPublicity ? 'Titre de la publicité' : 'Sujet du message')}
              </div>
              <span className={`priority-badge ${messageForm.priority}`}>
                {messageForm.priority === 'low' && 'Faible'}
                {messageForm.priority === 'normal' && 'Normale'}
                {messageForm.priority === 'high' && 'Élevée'}
                {messageForm.priority === 'urgent' && 'Urgente'}
              </span>
            </div>
            <div className="preview-content">
              {messageForm.content || (isPublicity ? 
                'Votre contenu publicitaire apparaîtra ici...' : 
                'Votre message apparaîtra ici...'
              )}
            </div>
            <div className="preview-footer">
              <div className="preview-recipient">
                {messageType === 'individual' ? 
                  `À: ${client?.name || 'Client sélectionné'}` : 
                  'À: Tous les clients'
                }
              </div>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="message-actions">
          <button 
            className="btn btn-secondary" 
            onClick={onClose}
          >
            Annuler
          </button>
          <button 
            className="btn btn-primary" 
            onClick={handleSendMessage}
            disabled={!messageForm.subject || !messageForm.content}
          >
            <FaPaperPlane />
            {isPublicity ? 'Envoyer la publicité' : 'Envoyer le message'}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default MessageModal;